import { Flex, SystemStyleObject, Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import IconTranscripts from '~/assets/svgs/icon-transcripts.svg?react'
import IconVoicemail from '~/assets/svgs/icon-voicemail.svg?react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { CustomTooltipActionButton } from '~/components/shared/CustomTooltip/CustomTooltipActionButton'
import { CallSentimentTooltip } from '~/pages/Calls/CallSentimentTooltip'
import { useDurationCellStyles } from '~/pages/Calls/componentStyles/CallsListItem.style'
import { Size } from '~/types/ThemeTypes'
import { tripLeadingZeroFromTime } from '~/utils/formatter'

import { BouncingEllipsis } from '../CallDetails/BouncingEllipsis'
import { VoicemailToolTip } from '../CallDetails/VoicemailToolTip'

interface DurationCellProps {
  columnStyles: SystemStyleObject
  duration: string
  hasVoicemail?: boolean
  callId: number
  pbxId: number
  transcriptId?: number
  customerSentimentScore?: number
  tableSize: Size
  onTranscriptClick?: () => void
  onVoicemailClick?: () => void
  voicemailId?: number
  isCallInProgress?: boolean
}
export const DurationCell = ({
  columnStyles,
  duration,
  hasVoicemail,
  callId,
  pbxId,
  transcriptId,
  onTranscriptClick,
  onVoicemailClick,
  customerSentimentScore,
  tableSize,
  voicemailId,
  isCallInProgress,
}: DurationCellProps) => {
  const styles = useDurationCellStyles()

  const isTranscriptSentimentNegative = !!(
    customerSentimentScore && customerSentimentScore <= -1
  )

  const trimmedDuration = useMemo(() => {
    return tripLeadingZeroFromTime(duration)
  }, [duration])

  const displayDuration = isCallInProgress ? (
    <BouncingEllipsis />
  ) : (
    <Text sx={styles.text}>{trimmedDuration}</Text>
  )

  return (
    <Flex sx={{ ...columnStyles, ...styles.container }}>
      <Flex sx={styles.wrapper}>
        <div>{displayDuration}</div>
        {tableSize == Size.sm && (
          <Flex sx={styles.iconWrapper}>
            {!!transcriptId && (
              <CustomTooltipActionButton
                icon={IconTranscripts}
                variant={
                  isTranscriptSentimentNegative
                    ? QuickActionButtonVariants.Destructive_100
                    : QuickActionButtonVariants.Default_100
                }
                size={Size.sm}
                tooltipText=""
                onButtonClick={onTranscriptClick}
                popoverContents={
                  transcriptId && (
                    <CallSentimentTooltip
                      pbxId={pbxId}
                      callId={callId}
                      callerSentiment={1}
                      officeSentiment={-1}
                    />
                  )
                }
              />
            )}
            {hasVoicemail && (
              <CustomTooltipActionButton
                icon={IconVoicemail}
                variant={QuickActionButtonVariants.Default_100}
                size={Size.sm}
                tooltipText=""
                popoverContents={
                  hasVoicemail && (
                    <VoicemailToolTip
                      voicemailId={voicemailId ?? 0}
                      pbxId={pbxId}
                      callId={callId}
                    />
                  )
                }
                onButtonClick={onVoicemailClick}
              />
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}
